module.exports = __webpack_public_path__ + "img/menu-banner-normal.1b4891a6.png";